import { createAsyncThunk, createSlice, isAnyOf } from "@reduxjs/toolkit";
import { FieldValues } from "react-hook-form";
import { toast } from "react-toastify";
import { LoginParams, User } from "../../models/user";
import agent from "../../api/agent";

interface AccountState {
  user: User | null;
}

const initialState: AccountState = {
  user: null,
};



function getAxiosParams(data: LoginParams) {
  const params = new URLSearchParams();
  params.append("phone", data.phone.toString());
  params.append("smscode", data.smscode.toString());

  return params;
}
export const signInUser = createAsyncThunk<User, FieldValues>(
  "account/signInUser",
  async (data, thunkAPI) => {
    try {
      const userDto = await agent.Account.login(
        getAxiosParams({ smscode: data.smscode, phone: data.phone })
      );
      if (userDto === "1") {
        localStorage.setItem("user", data.phone);
        localStorage.setItem("phonenumber",data.phone);
        localStorage.setItem("login", "true");
        localStorage.setItem("timestamp" , new Date().toISOString());
        return {
          phone: data.phone,
        };
      }
      return thunkAPI.rejectWithValue({
        error: "There is a problem in activating your account",
      });
    } catch (error: any) {
      return thunkAPI.rejectWithValue({ error: error.data });
    }
  }
);

export const fetchCurrentUser = createAsyncThunk<User | null>(
  "account/fetchCurrentUser",
  async (_, thunkAPI) => {
    thunkAPI.dispatch(
      setUser({
        phone: localStorage.getItem("user"),
      })
    );
    try {
      let userPhone = localStorage.getItem("user")!;
      let userObj = {
        phone: userPhone,
      };

      return userPhone ? userObj : null;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: () => {
      if (!localStorage.getItem("user")) return false;
    },
  }
);

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    signOut: (state) => {
      state.user = null;
      localStorage.removeItem("user");
    },
    setUser: (state, action) => {
      if (!action.payload) return;
      state.user = {
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCurrentUser.rejected, (state) => {
      state.user = null;
      localStorage.removeItem("user");
      toast.error("Session expired - please login again");
    });
    builder.addMatcher(
      isAnyOf(signInUser.fulfilled, fetchCurrentUser.fulfilled),
      (state, action) => {
        if (!action.payload) return;
        state.user = {
          ...action.payload,
          // roles: typeof roles === "string" ? [roles] : roles,
        };
      }
    );
    builder.addMatcher(isAnyOf(signInUser.rejected), (state, action) => {
      throw action.payload;
    });
  },
});

export const { signOut, setUser } = accountSlice.actions;
